import { forwardRef } from "react";
import styled from "@emotion/styled";
import { Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import UIcon from "lib/icons/untitled_ui/UIcon";

type EmptyComboboxTriggerProps = {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
} & React.ComponentPropsWithoutRef<"div">;

const StyledButton = styled(Button)(({ theme }) => ({
  border: "none",
  gap: 12,
  "&:hover": {
    backgroundColor: theme.colors.sysTextDefault + "0A", // 4% opacity
  },
}));

export const EmptyComboboxTrigger = forwardRef<HTMLDivElement, EmptyComboboxTriggerProps>(
  ({ label, onClick, disabled, ...rest }, ref) => {
    return (
      <div ref={ref} {...rest}>
        <StyledButton
          buttonType="secondary"
          buttonStyle="inverse"
          width="100%"
          justifyContent="left"
          onClick={onClick}
          disabled={disabled}
        >
          <UIcon icon="plus" color="sysTextPlaceholder" />
          <Text color="sysTextPlaceholder">{label}</Text>
        </StyledButton>
      </div>
    );
  },
);

EmptyComboboxTrigger.displayName = "EmptyComboboxTrigger";
